import { createAction } from "@ngrx/store";
import { AppError } from "@obg/ngx.core";

import { DepositLimitCalculatorPredictionsResponse } from "./deposit-limit-calculator.model";

export namespace DepositLimitCalculatorAction {
	const ACTION_PREFIX = "[Deposit Limit Calculator]";

	export const getPredictions = createAction(`${ACTION_PREFIX} Get Predictions`);

	export const getPredictionsSuccess = createAction(
		`${ACTION_PREFIX} Get Predictions Success`,
		(predictionsResponse: DepositLimitCalculatorPredictionsResponse) => ({ predictionsResponse })
	);

	export const getPredictionsFail = createAction(`${ACTION_PREFIX} Get Predictions Fail`, (error: AppError) => ({
		error,
	}));

	export const clear = createAction(`${ACTION_PREFIX} Clear`);
}
